import React from 'react';
import CheckSuccess from 'components/common/icons/onlineInterview/CheckSuccess';
import CheckError from 'components/common/icons/onlineInterview/CheckError';
import ClipSpinner from 'components/common/ClipSpinner/ClipSpinner';
import styles from 'components/Interview/OnlineInterview/ConnectionSettingsModal/ConnectionSettingsModal.module.scss';
import {ExclamationIcon} from '../components/common/icons';
import {mainGreen} from 'styles/variables';

const CHECK_STATES = {
    success: {icon: CheckSuccess, color: mainGreen},
    error: {icon: CheckError, color: '#f55a5a'},
    inProgress: {icon: ClipSpinner, color: mainGreen},
    warning: {icon: ExclamationIcon.bind(null, {color: '#ffb91f', height: '22', width: '22'}), color: '#ffb91f'},
};

const MINIMUM_DOWNLOAD_SPEED = 3;
const MINIMUM_UPLOAD_SPEED = 1.5;

function CheckResult({state, text}) {
    const {icon: CheckIcon, color} = state;
    return (
        <div className={styles.checkResult}>
            <CheckIcon className={styles.checkIcon} />
            <div style={{color}}>{text}</div>
        </div>
    );
}

const getSpeedText = (label, currentSpeed, t) => {
    const currentSpeedText = currentSpeed
        ? `${currentSpeed} mbps`
        : t('onlineInterview:connectionSettingsModal.checking');

    return `${label} ${currentSpeedText}`;
};

const getSpeedState = (currentSpeed, minSpeed) => {
    if (!currentSpeed) return CHECK_STATES.inProgress;

    return currentSpeed < minSpeed ? CHECK_STATES.error : CHECK_STATES.success;
};

export {CHECK_STATES, MINIMUM_DOWNLOAD_SPEED, MINIMUM_UPLOAD_SPEED, getSpeedState, getSpeedText, CheckResult};
